import { useState } from "react";
import { API } from "@/lib/api";

const WEBHOOK_KEY = "whk_4759ffff53c24c6daf8978983836095c";

const CSS = `
.cor-form-wrap, .cor-form-wrap *, .cor-form-wrap *::before, .cor-form-wrap *::after { box-sizing:border-box; margin:0; padding:0; }
.cor-page-bg { min-height:100vh; background:radial-gradient(ellipse at top,#0f1720 0%,#050810 60%); padding:80px 20px; display:flex; align-items:flex-start; justify-content:center; }
.cor-form-wrap { font-family:'Inter','Segoe UI',system-ui,sans-serif; background:#0d1117; border:1px solid #1e2a38; border-radius:16px; padding:48px 40px 44px; max-width:520px; width:100%; margin:0 auto; box-shadow:0 24px 64px rgba(0,0,0,.55); position:relative; overflow:hidden; }
.cor-form-wrap::before { content:''; position:absolute; top:-60px; right:-60px; width:220px; height:220px; background:radial-gradient(circle, rgba(56,189,248,.12) 0%, transparent 70%); pointer-events:none; }
.cor-close-btn { position:absolute; top:14px; right:14px; z-index:2; width:34px; height:34px; display:inline-flex; align-items:center; justify-content:center; background:rgba(148,163,184,.08); border:1px solid #1e2d40; border-radius:50%; color:#94a3b8; cursor:pointer; text-decoration:none; transition:all .18s; }
.cor-close-btn:hover { background:#f87171; border-color:#f87171; color:#fff; }
.cor-close-btn svg { width:16px; height:16px; }
.cor-form-header { margin-bottom:32px; }
.cor-form-eyebrow { font-size:11px; font-weight:600; letter-spacing:.12em; text-transform:uppercase; color:#38bdf8; margin-bottom:10px; }
.cor-form-title { font-size:26px; font-weight:700; color:#f0f6ff; line-height:1.25; margin-bottom:10px; }
.cor-form-subtitle { font-size:14px; color:#7a8fa6; line-height:1.6; }
.cor-field-group { display:flex; flex-direction:column; gap:16px; margin-bottom:24px; }
.cor-field { display:flex; flex-direction:column; gap:6px; }
.cor-field label { font-size:12.5px; font-weight:600; color:#94a3b8; }
.cor-field input, .cor-field textarea { background:#111827; border:1px solid #1e2d40; border-radius:8px; color:#e2eaf4; font-family:inherit; font-size:15px; padding:13px 16px; width:100%; outline:none; transition:border-color .18s, box-shadow .18s; appearance:none; }
.cor-field input::placeholder, .cor-field textarea::placeholder { color:#3a4d60; }
.cor-field input:focus, .cor-field textarea:focus { border-color:#38bdf8; box-shadow:0 0 0 3px rgba(56,189,248,.15); }
.cor-field input.cor-error, .cor-field textarea.cor-error { border-color:#f87171; box-shadow:0 0 0 3px rgba(248,113,113,.12); }
.cor-field textarea { resize:vertical; min-height:110px; line-height:1.55; }
.cor-field-error { font-size:12px; color:#f87171; margin-top:2px; }
.cor-row { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
@media (max-width:480px) { .cor-form-wrap { padding:36px 24px 32px; } .cor-form-title { font-size:22px; } .cor-row { grid-template-columns:1fr; } }
.cor-submit-btn { width:100%; background:linear-gradient(135deg,#0ea5e9 0%,#2563eb 100%); border:none; border-radius:9px; color:#fff; cursor:pointer; font-family:inherit; font-size:15px; font-weight:600; padding:15px 24px; box-shadow:0 4px 20px rgba(14,165,233,.3); transition:opacity .18s, transform .12s, box-shadow .18s; }
.cor-submit-btn:hover:not(:disabled) { opacity:.92; box-shadow:0 6px 28px rgba(14,165,233,.45); transform:translateY(-1px); }
.cor-submit-btn:disabled { opacity:.6; cursor:not-allowed; }
.cor-btn-text { display:inline-flex; align-items:center; gap:8px; justify-content:center; }
.cor-spinner { display:inline-block; width:17px; height:17px; border:2px solid rgba(255,255,255,.35); border-top-color:#fff; border-radius:50%; animation:cor-spin .7s linear infinite; }
@keyframes cor-spin { to { transform:rotate(360deg); } }
.cor-form-error-banner { background:rgba(248,113,113,.08); border:1px solid rgba(248,113,113,.3); border-radius:8px; color:#f87171; font-size:13.5px; padding:12px 16px; margin-top:16px; }
.cor-success { display:flex; flex-direction:column; align-items:center; text-align:center; padding:16px 0 8px; gap:20px; }
.cor-success-icon { width:64px; height:64px; background:rgba(56,189,248,.1); border:1px solid rgba(56,189,248,.25); border-radius:50%; display:flex; align-items:center; justify-content:center; }
.cor-success-icon svg { width:28px; height:28px; stroke:#38bdf8; fill:none; stroke-width:2.5; stroke-linecap:round; stroke-linejoin:round; }
.cor-success-title { font-size:22px; font-weight:700; color:#f0f6ff; }
.cor-success-body { font-size:14.5px; color:#7a8fa6; line-height:1.65; max-width:360px; }
.cor-form-footer { margin-top:18px; text-align:center; font-size:12px; color:#3a4d60; }
.cor-honeypot { position:absolute; left:-9999px; top:-9999px; height:0; width:0; opacity:0; pointer-events:none; }
`;

const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
const validPhone = (v) => /^[\d\s\-().+]{7,}$/.test((v || "").trim());

export default function GetStarted() {
  const [f, setF] = useState({ contact_name: "", business_name: "", email: "", phone: "", notes: "", _hp: "" });
  const [errors, setErrors] = useState({});
  const [banner, setBanner] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => {
    setF((s) => ({ ...s, [k]: e.target.value }));
    if (errors[k]) setErrors((s) => ({ ...s, [k]: null }));
  };

  const validate = () => {
    const e = {};
    if (!f.contact_name.trim())          e.contact_name  = "Please enter your name.";
    if (!f.business_name.trim())         e.business_name = "Please enter your business name.";
    if (!validEmail(f.email))            e.email         = "Please enter a valid email address.";
    if (!validPhone(f.phone))            e.phone         = "Please enter your phone number.";
    if (f.notes.trim().length < 5)       e.notes         = "Please describe your biggest challenge.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = async (ev) => {
    ev.preventDefault();
    setBanner("");
    if (!validate()) return;
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/webhook/leads/${WEBHOOK_KEY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contact_name:  f.contact_name.trim(),
          business_name: f.business_name.trim(),
          email:         f.email.trim(),
          phone:         f.phone.trim(),
          source:        "website",
          status:        "new",
          notes:         f.notes.trim(),
          _hp:           f._hp,   // honeypot — bots fill this, humans don't
        }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setDone(true);
    } catch {
      setBanner("Something went wrong. Please try again in a moment.");
      setSubmitting(false);
    }
  };

  return (
    <div className="cor-page-bg" data-testid="get-started-page">
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <div className="cor-form-wrap" id="cor-root">
        <a href="/" className="cor-close-btn" aria-label="Close and return home" data-testid="get-started-close" title="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </a>
        {!done ? (
          <div id="cor-form-body">
            <div className="cor-form-header">
              <p className="cor-form-eyebrow">Get Started Today</p>
              <h2 className="cor-form-title">Stop Missing Calls.<br />Start Winning Jobs.</h2>
              <p className="cor-form-subtitle">Tell us about your business and we'll show you exactly how many leads you're losing — and how to get them back.</p>
            </div>
            <form onSubmit={submit} noValidate data-testid="get-started-form">
              <div className="cor-field-group">
                <div className="cor-row">
                  <div className="cor-field">
                    <label htmlFor="cor-name">Your Name *</label>
                    <input id="cor-name" data-testid="gs-name" type="text" placeholder="Jane Smith" autoComplete="name"
                           value={f.contact_name} onChange={set("contact_name")}
                           className={errors.contact_name ? "cor-error" : ""} />
                    {errors.contact_name && <span className="cor-field-error" data-testid="gs-name-error">{errors.contact_name}</span>}
                  </div>
                  <div className="cor-field">
                    <label htmlFor="cor-biz">Business Name *</label>
                    <input id="cor-biz" data-testid="gs-biz" type="text" placeholder="Smith Plumbing Co." autoComplete="organization"
                           value={f.business_name} onChange={set("business_name")}
                           className={errors.business_name ? "cor-error" : ""} />
                    {errors.business_name && <span className="cor-field-error" data-testid="gs-biz-error">{errors.business_name}</span>}
                  </div>
                </div>
                <div className="cor-field">
                  <label htmlFor="cor-email">Email Address *</label>
                  <input id="cor-email" data-testid="gs-email" type="email" placeholder="jane@smithplumbing.com" autoComplete="email"
                         value={f.email} onChange={set("email")}
                         className={errors.email ? "cor-error" : ""} />
                  {errors.email && <span className="cor-field-error" data-testid="gs-email-error">{errors.email}</span>}
                </div>
                <div className="cor-field">
                  <label htmlFor="cor-phone">Phone Number *</label>
                  <input id="cor-phone" data-testid="gs-phone" type="tel" placeholder="(562) 555-0100" autoComplete="tel"
                         value={f.phone} onChange={set("phone")}
                         className={errors.phone ? "cor-error" : ""} />
                  {errors.phone && <span className="cor-field-error" data-testid="gs-phone-error">{errors.phone}</span>}
                </div>
                <div className="cor-field">
                  <label htmlFor="cor-challenge">What's your biggest challenge? *</label>
                  <textarea id="cor-challenge" data-testid="gs-notes" placeholder="e.g. Missing calls when I'm on a job, can't keep up with follow-ups..."
                            value={f.notes} onChange={set("notes")}
                            className={errors.notes ? "cor-error" : ""} />
                  {errors.notes && <span className="cor-field-error" data-testid="gs-notes-error">{errors.notes}</span>}
                </div>
              </div>
              {/* Honeypot: humans never see or fill this. Bots crawl the DOM and fill everything. */}
              <input type="text" tabIndex="-1" autoComplete="off" aria-hidden="true"
                     className="cor-honeypot" value={f._hp} onChange={set("_hp")}
                     name="website_url" placeholder="Leave blank" />
              <button type="submit" className="cor-submit-btn" data-testid="gs-submit" disabled={submitting}>
                <span className="cor-btn-text">
                  {submitting && <span className="cor-spinner" aria-hidden="true" />}
                  {!submitting && <span className="cor-btn-label">Get My Free Strategy Call</span>}
                  {submitting && <span>Sending…</span>}
                </span>
              </button>
              {banner && <div className="cor-form-error-banner" role="alert" data-testid="gs-error-banner">{banner}</div>}
            </form>
            <p className="cor-form-footer">No spam, ever. We'll reach out within one business day.</p>
          </div>
        ) : (
          <div className="cor-success" role="status" aria-live="polite" data-testid="gs-success">
            <div className="cor-success-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
            </div>
            <p className="cor-success-title">You're on the list.</p>
            <p className="cor-success-body">We've got your info and will be in touch within one business day. Check your email for a quick note from us.</p>
          </div>
        )}
      </div>
    </div>
  );
}
